import { compose, resolveConstant } from '../composer';

const assertHasMedicalAid = _ref => {
  let {
    coverage
  } = _ref;

  if (coverage) {
    return undefined;
  }

  return {
    type: 'error',
    messages: ['Patient does not have medical aid']
  };
};

const defaultMedicalAidAssertions = [assertHasMedicalAid];
export const validateMedicalAidCoverage = compose({
  getRuleName: () => 'has-medical-aid',
  defaultAssertions: defaultMedicalAidAssertions,
  defaultResolver: resolveConstant(true)
});
//# sourceMappingURL=medicalAid.js.map